import { N700, N900 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';

export const FormHeaderRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

interface FormHeaderHeadingProps {
  isGreeting: boolean;
}

export const FormHeaderHeading = styled.p<FormHeaderHeadingProps>`
  font-size: ${(props) => (props.isGreeting ? '24px' : '36px')};
  line-height: 40px;
  font-family: 'Charlie Display';
  margin: 0;
  margin-bottom: 0;
  font-weight: 500;
  word-break: break-all;
`;

export const ChooseSignupFormHeaderHeading = styled.h2`
  font-size: 36px;
  line-height: 44px;
  font-family: 'Charlie Display';
  margin: 0;
  margin-bottom: 13px;
  font-weight: 500;
  word-break: break-all;
  color: ${N700};
`;

export const FormHeaderSubheading = styled.p`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  font-family: 'Charlie Display';
  margin: 0;
  text-align: center;
`;

export const ChooseSignupFormHeaderSubheading = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0.03em;
  font-family: 'Charlie Display';
  color: ${N900};
  margin-top: 0;
  margin-bottom: 40px;
`;
